<span class="th-conteudo">
  <ng-content></ng-content>
  <mat-icon *ngIf="habilitado" class="th-icone" [class.ativo]="ativa">{{ icone }}</mat-icon>
</span>
